import * as audio from './audio.js';

export {
    init,
    addSounds,
    addImages,
    images,
}

const soundAssets = [];
const imageAssets = [];

const images = {};

function init() {
    return Promise.all([
        loadSounds(),
        loadImages(),
    ]);
}

function addSounds(sounds) {
    soundAssets.push(...sounds);
}

function addImages(images) {
    imageAssets.push(...images);
}

function loadSounds() {
    return Promise.all([
        ...soundAssets.map(sound => {
            return audio.buffers.load(sound.name, sound.url);
        }),
        audio.buffers.load('bruit-de-fond', new URL('../sound/bruit-de-fond.wav', import.meta.url)),
    ]).then(() => {
        if (DEVMODE) console.log(`${soundAssets.length} sounds loaded`);
    });
}

function loadImages() {
    return Promise.all([
        ...imageAssets.map(image => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    if (DEVMODE) console.log(`Image ${image.name} loaded`);
                    resolve();
                };
                img.onerror = () => {
                    reject(`Error loading image ${image.name}`);
                };
                img.src = image.url;
                images[image.name] = img;
                images[image.name].ppm = image.ppm;
            });
        }),
    ]).then(() => {
        if (DEVMODE) console.log(`${imageAssets.length} images loaded`);
    });
}